
import Vue, { PropType } from 'vue';
import Upload16 from '@carbon/icons-vue/es/upload/16';
import { CvRow, CvColumn, CvButton, CvMultiSelect } from '@carbon/vue';
import { SearchArtworks } from '../SearchArtworks';

export default Vue.extend({
  components: {
    CvColumn,
    CvRow,
    CvButton,
    Upload16,
    SearchArtworks,
    CvMultiSelect,
  },
  props: {
    tagOptions: {
      type: [] as PropType<string[]>,
      required: true,
    },
    selectedTags: {
      type: [] as PropType<string[]>,
      required: true,
    },
  },
  computed: {
    selectOptions() {
      return this.tagOptions.map((tagName) => ({
        value: tagName,
        label: tagName,
        name: tagName,
      }));
    },
  },
});
